import { render } from "./BlFormFieldSignatureDialog.vue?vue&type=template&id=22d89f98&scoped=true"
import script from "./BlFormFieldSignatureDialog.vue?vue&type=script&lang=js"
export * from "./BlFormFieldSignatureDialog.vue?vue&type=script&lang=js"

import "./BlFormFieldSignatureDialog.vue?vue&type=style&index=0&id=22d89f98&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d89f98"]])

export default __exports__